import State from "ducks/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State, props) => {
    const {
        template: {mainTemplate, fallbackTemplate},
    } = state

    return {
        mainTemplate,
        fallbackTemplate,
        props,
    }
}

export default connect(mapStateToProps)
